package org.bsvac.bsvac_kmp.data.models

import androidx.compose.ui.graphics.Color
import org.bsvac.bsvac_kmp.MainUiState
import org.bsvac.bsvac_kmp.MainViewModel

enum class ContentSectionId (val title: String, val isNavigatable: Boolean = true, val isActionable: Boolean = false) {
    CALL_INFO("Call\nInfo"),
    LOCATION_DATA("Location\nData"),
    MCI_LIST("MCI List"),
    MSG_LIST("MSG List"),
    UNIT_HISTORY("Unit\nHistory"),
    CLEAR_SCREEN("Clear\nScreen"),
    LOGON("Logon"),
    LOGOFF("Logoff"),
    EMPTY(title = "", isNavigatable = false),
    F1(title = "F1", isNavigatable = false, isActionable = true),
    F2(title = "F2", isNavigatable = false, isActionable = true),
    F3(title = "F3", isNavigatable = false, isActionable = true),
    F4(title = "F4", isNavigatable = false, isActionable = true),
    F5(title = "F5", isNavigatable = false, isActionable = true),
    F6(title = "F6", isNavigatable = false, isActionable = true),
    F7(title = "F7", isNavigatable = false, isActionable = true),
    F8(title = "F8", isNavigatable = false, isActionable = true),
    F9(title = "F9", isNavigatable = false, isActionable = true),
    MESSAGE_WAITING("Message\nWaiting 0"),
    DISPOSITIONS("DISPOSITIONS"),
    SCRATCH_PAD("SCRATCH PAD"),
    XMIT(title = "XMIT", isNavigatable = false, isActionable = true)


    ;

    fun onActionClicked(actionSelected: ContentSectionId, model: MainViewModel) {
        when (this) {
            LOGON -> {
                if (actionSelected == XMIT) {
                    model.displayErrorMessage("Trying to xmit")
                }
            }
            else -> {
                /* Do Nothing */
            }
        }
    }

    companion object {
        fun backgroundColor(contentSectionId: ContentSectionId, state: MainUiState) : Color {
            return when (contentSectionId) {
                CALL_INFO -> Color.Green
                XMIT -> Color.Green
                EMPTY -> Color.Yellow
                else -> Color.LightGray
            }
        }

        fun topRowIds(): List<ContentSectionId> {
            return listOf(
                CALL_INFO, LOCATION_DATA, MCI_LIST,
                MSG_LIST,
                UNIT_HISTORY,
                CLEAR_SCREEN,
                LOGON,
                LOGOFF,
                EMPTY
            )
        }

        fun middleColumnIds(): List<ContentSectionId> {
            return listOf(
                MESSAGE_WAITING, DISPOSITIONS, SCRATCH_PAD,
                XMIT,
                EMPTY
            )
        }

        fun bottomRowIds(): List<ContentSectionId> {
            return listOf(
                F1, F2, F3, F4, F5,
                F6,
                F7,
                F8,
                F9,)
        }
    }

}
